import React from 'react'

const ReachOut = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.5834 1.66675H6.66671C4.82576 1.66675 3.33337 3.15913 3.33337 5.00008V15.0001C3.33337 16.841 4.82576 18.3334 6.66671 18.3334H14.5834C16.4243 18.3334 17.9167 16.841 17.9167 15.0001V5.00008C17.9167 3.15913 16.4243 1.66675 14.5834 1.66675Z" stroke="#2F3237" strokeWidth="1.5"/>
    <path d="M8.825 11.4506C8.30104 11.8016 6.92717 12.5183 7.76395 13.4151C8.17271 13.8532 8.628 14.1666 9.20033 14.1666H12.4663C13.0387 14.1666 13.494 13.8532 13.9027 13.4151C14.7395 12.5183 13.3657 11.8016 12.8417 11.4506C11.6129 10.6275 10.0537 10.6275 8.825 11.4506Z" stroke="#2F3237" strokeWidth="1.5"/>
    <path d="M12.5 7.49992C12.5 8.42042 11.7538 9.16659 10.8333 9.16659C9.91279 9.16659 9.16663 8.42042 9.16663 7.49992C9.16663 6.57944 9.91279 5.83325 10.8333 5.83325C11.7538 5.83325 12.5 6.57944 12.5 7.49992Z" stroke="#2F3237" strokeWidth="1.5"/>
    <path d="M4.16671 5H2.08337M4.16671 10H2.08337M4.16671 15H2.08337" stroke="#2F3237" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
    
  )
}

export default ReachOut
